import React from "react";
import { ShipmentReconciliationSummaryTile } from "../../../shipment-reconciliation/summary-tile/shipmentReconciliationSummaryTile";
import {
  ShipmentReconciliationSummaryTileTypes,
  ShipmentReconciliationSummaryTypes,
} from "../../../../app/data/shipment-reconciliation/models";
import { PickupInboxStats } from "../../../../app/data/pickup-requests/models";
import { InboundProcessingState } from "../../../../app/data/communications/models";

export type InboxSummaryFilter =
  | { type: "hasPendingReview" }
  | { type: "processingState"; value: InboundProcessingState }
  | null;

export interface InboxSummaryTilesProps {
  stats?: PickupInboxStats;
  isLoading: boolean;
  activeFilter: InboxSummaryFilter;
  onApplyFilter: (filter: InboxSummaryFilter) => void;
}

const formatCount = (num: number) => {
  if (num >= 1000) return `${(num / 1000).toFixed(1).replace(/\.0$/, "")}K`;
  return String(num);
};

const InboxSummaryTiles: React.FC<InboxSummaryTilesProps> = ({
  stats,
  isLoading,
  activeFilter,
  onApplyFilter,
}) => {
  const filtersApplied = activeFilter != null;

  return (
    <div className="xgs-pickup-inbox__summary">
      <div className="xgs-pickup-inbox__summary-row">
        <ShipmentReconciliationSummaryTile
          tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
          type={ShipmentReconciliationSummaryTypes.PENDING_FOR_REVIEW}
          isLoading={isLoading}
          title="Pending review (emails)"
          value={stats ? formatCount(stats.pendingReviewEmailCount) : 0}
          legendDescription="Distinct inbound emails needing human review. Matches inbox filter hasPendingReview=true."
          onApply={() => onApplyFilter({ type: "hasPendingReview" })}
        />
        <ShipmentReconciliationSummaryTile
          tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
          type={ShipmentReconciliationSummaryTypes.REVIEW_PROGRESS}
          isLoading={isLoading}
          title="Messages processing"
          value={stats?.messages?.processing ?? 0}
          legendDescription="Inbound messages currently in PROCESSING state."
          onApply={() => onApplyFilter({ type: "processingState", value: "PROCESSING" })}
        />
        <ShipmentReconciliationSummaryTile
          tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
          type={ShipmentReconciliationSummaryTypes.REVIEWED}
          isLoading={isLoading}
          title="Completed"
          value={stats ? formatCount(stats.completed) : 0}
          legendDescription="Filter inbox to messages with processingState COMPLETED."
          onApply={() => onApplyFilter({ type: "processingState", value: "COMPLETED" })}
        />
        <ShipmentReconciliationSummaryTile
          tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
          type={ShipmentReconciliationSummaryTypes.REJECTED}
          isLoading={isLoading}
          title="Failed"
          value={stats ? formatCount(stats.failed) : 0}
          legendDescription="Filter inbox to messages with processingState FAILED."
          onApply={() => onApplyFilter({ type: "processingState", value: "FAILED" })}
        />
        {filtersApplied && (
          <div className="xgs-pickup-inbox__summary-filters-note">
            Filters applied to results below.
          </div>
        )}
      </div>
    </div>
  );
};

export default InboxSummaryTiles;
